import React from 'react';
import theme from '../../theme/theme';

const Card = ({ title, subTitle, icon, value, color }) => (
    <div className="glass-card" style={{ padding: '1.25rem', marginBottom: '1rem', position: 'relative', overflow: 'hidden', borderLeft: `4px solid ${color}` }}>
        <div className="flex-between">
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <div style={{ color: color }}>{icon}</div>
                <span style={{ fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-primary)' }}>{title}</span>
            </div>
        </div>

        <div style={{ marginTop: '0.75rem' }}>
            <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginBottom: '0.25rem' }}>
                {subTitle}
            </p>
            <p style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--primary-main)' }}>
                {value}
            </p>
        </div>
    </div>
);

const InsightCards = ({ clusterInsights, loading }) => {
    if (loading) return <div>Loading insights...</div>;

    if (!clusterInsights || !clusterInsights.clusterSizes) {
        return <div style={{ padding: '1rem', color: 'var(--text-secondary)' }}>No insights available</div>;
    }

    const { clusterSizes, numCentroids } = clusterInsights;
    // content of clusterSizes is like { "0": 14027, "1": 6011 }
    const clusters = Object.entries(clusterSizes);

    if (clusters.length === 0) {
        return <div style={{ padding: '1rem', color: 'var(--text-secondary)' }}>No cluster data</div>;
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            backgroundColor: theme.palette.background.paper,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(2),
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)'
        }}>
            <h4 style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
                Found {numCentroids} Clusters
            </h4>
            {clusters.map(([clusterId, size], idx) => (
                <Card
                    key={clusterId}
                    title={`Cluster ${clusterId}`}
                    subTitle="Data Points"
                    value={size.toLocaleString()}
                    color={idx % 2 === 0 ? 'var(--secondary-main)' : 'var(--primary-main)'}
                    icon={
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="8" x2="12" y2="16"></line>
                            <line x1="8" y1="12" x2="16" y2="12"></line>
                        </svg>
                    }
                />
            ))}
        </div>
    );
};

export default InsightCards;
